import { useNavigate, useLocation } from "react-router-dom";

export default function NotFound() {
  const nav = useNavigate();
  const loc = useLocation();
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-3 p-6 text-center" data-testid="not-found-page">
      <div className="text-silver text-3xl">Page not found</div>
      <div className="text-sm opacity-70 break-all max-w-md" data-testid="not-found-path">
        <code>{loc.pathname}</code> isn't a page in the Hub.
      </div>
      <div className="flex gap-2 mt-2">
        <button className="btn-silver" onClick={() => nav("/")} data-testid="btn-nf-dashboard">Back to Dashboard</button>
        <button className="btn-ghost" onClick={() => nav(-1)} data-testid="btn-nf-back">← Go back</button>
      </div>
    </div>
  );
}
